import {Component, inject} from '@angular/core';
import {ViewportService} from "src/app/infrastructure/viewport.service";
import {LoginComponent} from "src/app/presentation/main-view/login/login.component";

@Component({
  selector: 'app-login-page',
  imports: [
    LoginComponent
],
  templateUrl: './login-page.component.html',
  styleUrl: './login-page.component.css'
})
export class LoginPage {

  protected viewportService = inject(ViewportService);

  constructor() {
    this.viewportService.checkViewportSize();
  }
}
